import { useTheme } from '@mui/material';
const useSectionHeaderStyles = () => {
    const theme = useTheme();
    return {
        sectionHeaderStyles: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 1,
            px: 2
        },
        actionContainerStyles: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 2.5
        },
        titleStyles: {
            color: theme.palette.text.secondary
        },
        incidentRangeContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            py: 1
        },
        scoreRangeContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            py: 1
        },
        locationFieldContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            py: 1
        },
        dateRangeContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            py: 1,
            gap: 1.5
        },
        datePickerContainerStyles: {
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center'
        },
        applyButtonContainerStyles: {
            width: '100%',
            pt: 1.5
        }
    };
};
export default useSectionHeaderStyles;
